import ModalComponent from "..";
import { BaseApiErrorResponse, ModalCompProps } from "../../../utils/types";
import { Button } from "../../buttons/button";
import { InfoComponent } from "../../notification/infoComponent";
import { SelectInput } from "../../inputs/selectInput";
import { useState } from "react";
import { useChangeAdminRoleMutation } from "../../../redux/features/admin/admin.api";

export const ChangeAdminRole = ({
  open,
  handleClose,
  onSuccess,
  adminId,
  adminRole,
  refetchAdmin,
}: ModalCompProps & {
  onSuccess: () => void;
  adminId: string;
  adminRole: string;
  refetchAdmin: () => void;
}) => {
  const [changeAdminRole, { isLoading, isError, error }] =
    useChangeAdminRoleMutation();
  const [selectedRole, setSelectedRole] = useState<string>(adminRole);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const resp = await changeAdminRole({
        adminId,
        payload: { role: selectedRole },
      }).unwrap();
      if (resp?.status === "success") {
        onSuccess();
        refetchAdmin();
        handleClose();
      }
    } catch (error) {
      console.error("Error changing admin role:", error);
    }
  };

  return (
    <ModalComponent
      open={open}
      handleClose={() => {
        handleClose();
      }}
      className=""
      dialogClassName=""
      closeOnOverlayClick
      showHeader
      title="Change Admin Role"
      showIcon={true}
      iconType={"refresh-big"}
      iconWidth={21}
      iconHeight={20}
      showBackIcon={false}
      mobileAnchorBottom
      showCloseIcon={false}
    >
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        {isError && (
          <InfoComponent
            title="Error"
            text={
              (error as unknown as BaseApiErrorResponse)?.data?.message ??
              "An error occurred!"
            }
            type="error"
          />
        )}
        <div className="flex w-full flex-col gap-2.5">
          <SelectInput
            title="Super admin"
            subTitle="They can manage other admins"
            iconSvg="user-settings"
            iconWidth={25}
            selected={selectedRole === "super-admin"}
            onSelect={() => setSelectedRole("super-admin")}
          />
          <SelectInput
            title="Admin"
            subTitle="They can’t invite or delete other admins"
            iconSvg="user"
            selected={selectedRole === "admin"}
            onSelect={() => setSelectedRole("admin")}
          />
        </div>
        <div className="col-span-full flex items-center justify-end gap-2">
          <Button
            text={"Cancel"}
            type="button"
            onClick={() => {
              handleClose();
            }}
            variation="plain-grey"
            className="max-w-fit"
          />
          <Button
            text={"Change Role"}
            type="submit"
            className="max-w-fit"
            loading={isLoading}
            disabled={isLoading}
            variation={"primary"}
          />
        </div>
      </form>
    </ModalComponent>
  );
};
